import { useDictionary } from "@adamlip/okeoke.client";
import { UserContext } from "contexts/UserContext";
import { useContext } from "react";
import toast from "react-hot-toast";
import QRCodeSVG from "qrcode.react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "@nextui-org/react";
import { AppParamsContext } from "contexts/AppParamsContext";

export default function Referal() {
  const { userData } =
    useContext(UserContext);
  const { getValue } = useDictionary();
  const { appParams } = useContext(AppParamsContext);

  //const [localRefID, setLocalRefID] = useState("");
  //const [inputHidden, setInputHidden] = useState(false);

  const { refID } = userData || {};

  // const handleSaveReferal = (id) => {
  //   if (referredByID != null) {
  //     toast.error(getValue("app_v2_referal_error"));
  //     console.log("error");
  //   } else {
  //     saveReferal(id, handleResponse);
  //   }
  // };

  // const handleResponse = (res) => {
  //   if (res.success) {
  //     toast.success(getValue("app_v2_referal_success"));
  //     //setInputHidden(true);
  //     // handleChangeUserData({
  //     //   target: { name: "referredByID", value: localRefID },
  //     // });
  //   } else {
  //     toast.error(res.message);
  //   }
  // };

  let classNames =
    "py-2 px-2 my-2 ml-1 mr-1 font-bold text-xl border-[var(--button-bg-color)] border-1";

  return (
    <div
      className={`flex flex-col gap-4 grow overflow-hidden ${appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        }`}
    >
      <div className="font-bold text-xl">
        {getValue("app_v2_referal_title")}
      </div>
      <div className="overflow-auto">
        <div className="font-normal text-center normal-case">
          {getValue("app_v2_referal_desc")}
          <span className="font-bold">{getValue("app_v2_referal_desc3")}</span>
        </div>
        {refID != null && (
          <>
            <div className="flex flex-wrap mb-2 justify-center">
              <div className={classNames}>{refID[0]}</div>
              <div className={classNames}>{refID[1]}</div>
              <div className={classNames}>{refID[2]}</div>
              <div className="py-4 px-1 text-xl flex items-center font-bold">
                -
              </div>
              <div className={classNames}>{refID[3]}</div>
              <div className={classNames}>{refID[4]}</div>
              <div className={classNames}>{refID[5]}</div>
            </div>
            <div className="flex justify-center">
              <QRCodeSVG
                value={`${window.location.origin}/brandApp/referal/${refID}`}
                includeMargin={true}
                renderAs="svg"
                size={160}
                level="H"
                bgColor={"#FFFFFF"}
                fgColor={"#000000"}
              />
            </div>
            <div className="flex justify-center">
              <CopyToClipboard
                text={`${window.location.origin}/brandApp/referal/${refID}`}
                onCopy={() =>
                  toast.success(getValue("app_v2_profile_ref_id_copied"))
                }
              >
                <Button color="secondary" className="mt-4" size="lg">
                  {getValue("app_v2_profile_ref_id_copy")}
                </Button>
              </CopyToClipboard>
            </div>
          </>
        )}
        {/* <div className="">
          {!inputHidden && referredByID == null && (
            <>
              <div className="mb-2">{getValue("app_v2_referal_desc2")}</div>
              <CustomInput
                name="referredByID"
                label={getValue("app_v2_profile_ref_id")}
                value={localRefID}
                onChange={(e) => setLocalRefID(e.target.value)}
              />
              <div
                className="btn btn-primary"
                onClick={() => handleSaveReferal(localRefID)}
              >
                {getValue("app_v2_profile_ref_id_save")}
              </div>
            </>
          )}
        </div> */}
      </div>
    </div>
  );
}
